'use client';

import DashboardView from './DashboardView';
import { useProject } from '@/contexts/ProjectContext';

export default function DashboardLayout() {
  const { selectedDashboard } = useProject();

  if (!selectedDashboard) {
    return null;
  }

  return (
    <div className="flex-1 overflow-hidden flex flex-col">
      <DashboardView dashboardType={selectedDashboard} />
    </div>
  );
}



